(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("gamificationResource", ["$resource", gamificationResource]);
    function gamificationResource($resource) {
        return $resource("/api/gamification/:action", { action: "@action" }, {
            getGamificationViewModel: {
                method: "GET",
                params: { action: "gamificationViewModel" }
            },
            enable: {
                method: "POST",
                params: { action: "enable" }
            },
            disable: {
                method: "POST",
                params: { action: "disable" }
            },
            enableSystem: {
                method: "POST",
                params: { action: "enableSystem" }
            },
            disableSystem: {
                method: "POST",
                params: { action: "disableSystem" }
            },
            getPointSystemViewModel: {
                method: "GET",
                params: { action: "pointSystemViewModel" }
            },
            disablePointSystemSetting: {
                method: "POST",
                params: { action: "disablePointSystemSetting" }
            },
            enablePointSystemSetting: {
                method: "POST",
                params: { action: "enablePointSystemSetting" }
            },
            updateItemCompletionGamificaitonHistoryForAllLearners: {
                method: "POST",
                params: { action: "updateItemCompletionGamificaitonHistoryForAllLearners" }
            },
            updateAcingExamPointsForAllLearners: {
                method: "POST",
                params: { action: "updateAcingExamPointsForAllLearners" }
            },
            editPointSystem: {
                method: "POST",
                params: { action: "editPointSystem" }
            },
            getTierSystemViewModel: {
                method: "GET",
                params: { action: "tierSystemViewModel" }
            },
            updateTierSystem: {
                method: "POST",
                params: { action: "updateTierSystem" }
            },
            getLeaderboardSystemViewModel: {
                method: "GET",
                params: { action: "leaderboardSystemViewModel" }
            },
            updateLeaderboardSystem: {
                method: "POST",
                params: { action: "updateLeaderboardSystem" }
            }
        });
    }
}());
